module.exports = __webpack_public_path__ + "img/dooby-life-logo.49a3575f.png";